import { CheckCheck } from 'lucide-react';
import { type FC } from 'react';

import type { InterfaceService } from '@/types';

import getFormattedSyncedTime from '@/utils/helpers/get-formatted-synced-time';

interface InterfaceSyncTimeProps {
  lastSynced?: InterfaceService['lastSynced'];
  isShowCheckIcon?: boolean;
}

const InterfaceSyncTime: FC<InterfaceSyncTimeProps> = ({ lastSynced, isShowCheckIcon }) => {
  if (!lastSynced) {
    return null;
  }

  const synced = getFormattedSyncedTime(lastSynced);

  if (!synced) {
    return null;
  }

  const { time, date } = synced;

  return (
    <div className="flex gap-1 whitespace-nowrap text-right text-xs leading-snug font-medium text-subtext">
      {isShowCheckIcon && <CheckCheck className="size-4 text-muted-foreground" />}
      <span>{date}</span>
      <span>{time}</span>
    </div>
  );
};

export default InterfaceSyncTime;
